import Component from './entry_history_dialog.vue'
export default Component
